import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonNonRecoverableErrorsCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import {
  transformNonRecoverableErrorResponse,
  trasformNonRecoverableError,
} from '../utils/transform-non-recoverable-error';
import FormNonRecoverableError from 'system/components/non-recoverable-errors/form';
import { noop } from 'shell/utils/noop';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useEventCallback } from '@mui/material';
import { NonRecoverable } from 'shell/models/non-recoverable-error';
import React from 'react';

const NonRecoverableErrorDetailPage = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();

  const deleteData = useHttpClient(
    `${__OPERATION__EVENT__ADMIN__}/eventoInErrore/DLQ/${params.id}`,
    { options: { method: 'DELETE' } }
  );

  const onDeletePress = useEventCallback(() => {
    (deleteData() as ResponsePromise<void>).then(() => {
      navigate('/sistema/eventmanager/gestione-errori-non-recuperabili');
    });
  });

  const [nonRecoverableError] = useHttpFetch<
    HttpResponse<NonRecoverable>,
    transformNonRecoverableErrorResponse
  >(`${__OPERATION__EVENT__ADMIN__}/eventoInErrore/DLQ/${params.id}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: trasformNonRecoverableError,
  });

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonNonRecoverableErrorsCrumbs, { name: 'Dettaglio evento non recuparabile' }]}
      />
      <FormNonRecoverableError
        title="Dettaglio evento non recuperabile"
        initialValues={nonRecoverableError?.data as transformNonRecoverableErrorResponse}
        onOk={noop}
        onDelete={onDeletePress}
        disabled
        onCancel={() => {
          navigate('/sistema/eventmanager/gestione-errori-non-recuperabili');
        }}
      />
    </Fragment>
  );
};

NonRecoverableErrorDetailPage.displayName = 'Non Recoverable Error Page Detail component';

export default NonRecoverableErrorDetailPage;
